import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  margin: 0 0 8px 0;
  color: #374151;
  font-size: 24px;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 14px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-weight: 600;
  color: #374151;
  font-size: 14px;
`;

export const Input = styled.input`
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #8b5cf6;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
`;

export const Overview = styled.div<{ red?: boolean }>`
  background-color: ${props => props.red ? '#fef2f2' : '#f9fafb'};
  border-radius: 12px;
  padding: 20px;
  border: 1px solid ${props => props.red ? '#fecaca' : '#e5e7eb'};
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InfoLabel = styled.span`
  color: #6b7280;
  font-size: 14px;
`;

export const InfoValue = styled.span<{ positive?: boolean; negative?: boolean }>`
  color: ${props => {
    if (props.positive) return '#059669';
    if (props.negative) return '#dc2626';
    return '#374151';
  }};
  font-weight: 600;
  font-size: 14px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;

  button {
    flex: 1;
  }
`;
